import PropTypes from "prop-types";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Grid, Button, Paper } from "@mui/material";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  closeButton: {
    minWidth: "unset",
    padding: 0,
    fontSize: "24px",
    borderRadius: 0,
  },
  modalWrapper: {
    position: "fixed",
    placeContent: "center",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: "100%",
    height: "100%",
    overflow: "auto",
    zIndex: "10002",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    backgroundColor: "#00000098",
    paddingRight: 17,
    "@media screen and (maxWidth: 700)": {
      placeContent: "flex-start",
    },
  },
  containerInner: {
    padding: "20px",
    width: "100%",
    "@media screen and (max-width: 500px)": {
      padding: "0 16px",
    },
    gap: "10px",
  },
  paper: {
    borderRadius: "5px",
    boxShadow: "2.5px 5px #464646",
    maxWidth: "500px",
  },
  title: {
    color: "#2eb790",
    fontSize: "24px",
    fontWeight: "500"
  }
});

const ResultsWrapper = ({ children, togglePreview }) => {
  const classes = useStyles();
  return (
    <div className={classes.modalWrapper}>
      <Paper variant="outlined" className={classes.paper}>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <Grid item xxs={9.5} xs={9.4} sm={9} md={8.944}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>
                <div className={classes.title}>Application Letter</div>
              </Grid>
              <Grid item>
                <Button
                  disableRipple={true}
                  variant="text"
                  className="button--modal_cancelJob"
                  aria-label="Close modal"
                  onClick={togglePreview}
                >
                  <CloseRoundedIcon fontSize="inherit" color="inherit" />
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {children}
      </Paper>
    </div>
  );
};

export default ResultsWrapper;

ResultsWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  togglePreview: PropTypes.func,
};
